// extracted by mini-css-extract-plugin
export default {"button-square":"button-square--Z1Cch","buttonSquare":"button-square--Z1Cch"};